import { ClassValue } from 'clsx';
import { PropsWithChildren, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '@shared/ui/components/Icon';
import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

type AdminWrapperProps = PropsWithClassName<{
  title?: string;
  actions?: ReactNode;
  breadcrumb?: { label: string; url: string };
  innerClassName?: ClassValue;
}>;

export function AdminWrapper({
  title,
  actions,
  breadcrumb,
  children,
  className,
  innerClassName,
}: PropsWithChildren<AdminWrapperProps>) {
  const showHeader = Boolean(title || actions || breadcrumb);

  return (
    <div className={cn('pt-8 pb-8', className)}>
      {showHeader && (
        <header className="flex items-center gap-6">
          {title && <h3 className="text-2xl font-medium text-gray-700 py-1">{title}</h3>}
          {actions && <div className="ml-auto flex gap-3">{actions}</div>}
          {breadcrumb && (
            <nav className="pr-6 border-r-2">
              <Link to={breadcrumb.url} className="text-gray-500 no-underline">
                <Icon icon="arrow-left" className="mr-1" />
                Back to {breadcrumb.label}
              </Link>
            </nav>
          )}
        </header>
      )}
      <div className={cn('mt-8', innerClassName)}>{children}</div>
    </div>
  );
}
